import { DragDropDraggableItem } from '../../../DragDrop'
import { CalendarGridChip } from '../../CalendarGridChip'
import { CalendarGridDayPopoverTrigger } from '../../CalendarGridDayPopoverTrigger'
import { CalendarGridItemTrigger } from '../../CalendarGridItemTrigger'

import {
  getCalendarGridDayChipDragId,
  getIsCalendarGridDayChipDragDisabled,
} from './CalendarGridDayChipsItem.utils'

function CalendarGridDayChipsItem({
  canMoveItems,
  day,
  dayItems,
  dayLoad,
  getIsItemDragDisabled = getIsCalendarGridDayChipDragDisabled,
  item,
  onClickItem,
  onClickSecondaryLabel,
}) {
  return item.opensDayPopover ? (
    <CalendarGridDayPopoverTrigger
      Trigger={CalendarGridChip}
      day={day}
      dayLoad={dayLoad}
      items={dayItems}
      triggerProps={{ item }}
      onClickItem={onClickItem}
      onClickSecondaryLabel={onClickSecondaryLabel}
    />
  ) : (
    <DragDropDraggableItem
      keepInPlace
      draggableProps={{
        data: { day, item },
        disabled: getIsItemDragDisabled({ canMoveItems, item }),
      }}
      id={getCalendarGridDayChipDragId({ day, item })}
    >
      <CalendarGridItemTrigger
        Trigger={CalendarGridChip}
        item={item}
        triggerProps={{ item }}
        onClickItem={onClickItem}
      />
    </DragDropDraggableItem>
  )
}

export default CalendarGridDayChipsItem
